import { SubRoutes } from '@view/routes';
// Lives in the business layer so `@data/other/i18n` can use it without the data
// layer importing from `@view/*`.
export { parseUrlLanguage } from '@business/utils/language-locale';
export function parseUrlPropertyCode(pathname) {
    const segments = pathname.split('/').filter(Boolean);
    const knownRoutes = Object.values(SubRoutes);
    const reservationPaths = ['reservation', 'reservas'];
    const last = segments[segments.length - 1];
    const secondLast = segments[segments.length - 2];
    const thirdLast = segments[segments.length - 3];
    // Case 1: Ends with a known route, code is before it
    if (reservationPaths.includes(thirdLast) &&
        !knownRoutes.includes(secondLast) &&
        !reservationPaths.includes(secondLast) &&
        knownRoutes.includes(last)) {
        return secondLast;
    }
    // Case 2: Ends with the code directly after reservation/reservas
    if (reservationPaths.includes(secondLast) &&
        !knownRoutes.includes(last) &&
        !reservationPaths.includes(last)) {
        return last;
    }
    return undefined;
}
